import { useFetchPartnerSandboxOrderQuery } from 'domains/connect/api'

export const usePartnerSandboxOrder = (partnerId: string, orderId: string) => {
  const { data, loading, error } = useFetchPartnerSandboxOrderQuery({
    variables: { partnerId, orderId },
    skip: orderId == '',
  })

  const sandboxOrder = data && data.partner.sandboxOrder

  return {
    sandboxOrder,
    loading,
    error,
  }
}
